import { Stack, Typography } from "@mui/material";
import CustomDataGrid from "components/customDataGrid";
import { currencyFormat } from "config/functions";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";
import TooltipMonth from "./TooltipMonth";
import NullCheck from "components/NullCheck";

const Forecast = ({ data, title, subTitle, hasTotal, isBuildCustomer }) => {
    const { bt } = useBizTypeTranslation();
    const [total, setTotal] = useState()

    useEffect(() => {
        if (hasTotal) {
            const totalRow = data?.find(r => r.id === "total");
            const sum = totalRow
                ? Object.keys(totalRow)
                    .filter(key => !isNaN(key)) // רק חודשים
                    .reduce((acc, key) => acc + Number(totalRow[key] || 0), 0)
                : 0;

            setTotal(sum.toFixed(2));
        }
    }, [data]);

    return (
        <Stack padding={{ xs: 0, md: 1 }}>
            <Stack height="100%" alignItems="center" direction="row" spacing={1}>
                <NullCheck valueForCheck={title}>
                    <Typography fontSize={{ xs: 12, md: 14 }}>
                        {title}
                    </Typography>
                </NullCheck>

                <NullCheck valueForCheck={hasTotal}>
                    <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                        {currencyFormat(total)}
                    </Typography>
                </NullCheck>
            </Stack>

            <CustomDataGrid
                hideFooter={isBuildCustomer ? false : true}
                pageSize={isBuildCustomer ? 5 : 100}
                excelBorder
                autoHeight
                selectedCol
                disableColumnSorting
                rowHeight={35}
                headerHeight={35}
                headerAlign="center"
                rowAlign="center"
                borderRadius="10px 10px 10px 10px"
                columns={[
                    {
                        field: "name",
                        headerName: bt(isBuildCustomer ? "NAME" : "TYPE"),
                        width: isBuildCustomer ? 120 : 85,
                        filterable: isBuildCustomer ? true : false,
                        renderCell: (params) => {
                            return (
                                <Typography variant="body2" fontWeight={params?.row?.id === "total" ? "bold" : "normal"}>
                                    {bt(params?.formattedValue)}
                                </Typography>
                            )
                        }
                    },
                    {
                        field: "1",
                        headerName: bt("JANUARY"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 1;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "2",
                        headerName: bt("FEBRUARY"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 2;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "3",
                        headerName: bt("MARCH"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 3;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "4",
                        headerName: bt("APRIL"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 4;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "5",
                        headerName: bt("MAY"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 5;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "6",
                        headerName: bt("JUNE"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 6;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "7",
                        headerName: bt("JULY"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 7;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "8",
                        headerName: bt("AUGUST"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 8;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "9",
                        headerName: bt("SEPTEMBER"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 9;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "10",
                        headerName: bt("OCTOBER"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 10;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "11",
                        headerName: bt("NOVEMBER"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 11;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth
                                    bt={bt}
                                    isBuildCustomer={isBuildCustomer}
                                    params={params}
                                    documents={documents}
                                />
                            );
                        }
                    },
                    {
                        field: "12",
                        headerName: bt("DECEMBER"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            const month = 12;
                            const documents = params?.row?.monthDetails?.[month]?.documents || [];
                            return (
                                <TooltipMonth bt={bt} isBuildCustomer={isBuildCustomer} params={params} documents={documents} />
                            );
                        }
                    },
                    {
                        field: "summary",
                        headerName: bt("SUMMARY"),
                        width: 85,
                        filterable: false,
                        renderCell: (params) => {
                            return (
                                <Typography variant="body2" fontWeight="bold">
                                    {currencyFormat(params?.formattedValue)}
                                </Typography>
                            )
                        }
                    },
                ]}
                list={data}
            />
        </Stack>
    );
};

export default Forecast;